// extracted by mini-css-extract-plugin
export default {"enabledIcon":"ChecksTab_enabledIcon__7xHvU"};